// extracted by css-extract-rspack-plugin
export default {"middlePaneWrapper":"MilestoneCreateEdit-module__middlePaneWrapper__V_Aggax","milestonePageDescription":"MilestoneCreateEdit-module__milestonePageDescription__H0lBwM0"};